import { useEffect, useState } from "react";
import Form from "./views/Form"
import Left from "./views/Left";
import { getSetting, send, setSetting, subscribeSetting } from "./service";
import { envs } from "./evns";
import { ForgetPassword } from "./views/ForgetPassword";
import { SSO } from "./views/SSO";
// import { CloseNew } from "./views/components/LeftIcon"; // Frank's needs: 2025-05-30 (remove close button temporarily)
import { isLite } from "./lite";

const defaultWords = {
  title: getSetting().title || "Create Your Free Account",
  btnTitle: getSetting().btnTitle || "START USING NOW",
  bottomWord: "Already have an account?",
  guideWord: "Log in",
  policyWord: "registering"
}
const loginWords = {
  title: "Login to Trucker Path COMMAND",
  btnTitle: "LOGIN",
  bottomWord: "Don't have an account?",
  guideWord: "Create a free account here",
  policyWord: "clicking login"
}
const loginWordsNavPro = {
  title: "Login to Trucker Path NavPro",
  btnTitle: "LOGIN",
  bottomWord: "Don't have an account?",
  guideWord: "Create a free account here",
  policyWord: "clicking login"
}

let opened = false
function App() {
  const [containerShow, setContainerShow] = useState(true)
  const [setting, _setSetting] = useState(getSetting());
  const [saveLogin, setSaveLogin] = useState({ email: "", password: "", rememUser: undefined });

  const setAllShow = s => {
    if (!s) {
      send({ action: 'close' })
      setSetting({ onlyForm: null })
      setContainerShow(false)
    }
  }
  const loginWordClick = () => {
    if (getSetting().isNew) {
      setSetting({ isLogin: !setting.isLogin })
      return
    }

    let url = envs.url + "login?" + setting?.utmStr || ""
    send({ action: 'navigate', url: url })
  }

  useEffect(() => {
    subscribeSetting(s => {
      s !== setting && _setSetting(s)
      if (!opened && s.origin && s.onlyForm !== null) {
        opened = true
        send({ action: 'opened' })
      }
      if (s.isInit) {
        setContainerShow(true)
      }
      if (s.customStyle) {
        const newStyle = document.createElement("style");
        const newContent = document.createTextNode(s.customStyle.replace("<style>", "").replace("</style>", ""));
        newStyle.appendChild(newContent);
        document.head.appendChild(newStyle);
      }
      setAndroidStyles()
    })

    removeStyles()
  }, []);
  function setAndroidStyles() {
    const reg = /Android/i.test(navigator.userAgent)
    const root = document.getElementById('root')
    if (reg && root.clientWidth > root.clientHeight && (root.clientHeight > 450 || root.clientWidth > 450)) {
      document.getElementById("rotate-con").classList.add("rotate-con-android")
    }
  }
  window.addEventListener("resize", setAndroidStyles, false)

  function removeStyles() {
    const reg = /Android|webOS|iPhone|iPod|BlackBerry|iPad/i.test(navigator.userAgent)
    const link1 = document.getElementById('h5CSS')

    if (!reg && link1) {
      document.head.removeChild(link1);
    }
  }

  function h5LinkClick(url) {
    send({ action: 'navigate', url })
  }

  const descWords = setting.isLogin ? (isLite ? loginWordsNavPro : loginWords) : defaultWords;

  return (<>
    <div className="App CPCK">
      {containerShow && setting && setting.originHref &&
        <div className={`background-wrapper  ${setting.onlyForm ? 'onlyForm' : ''}`}>
          <div className={`container ${setting.onlyForm ? 'onlyForm' : ''}`}>
            {
              !setting.onlyForm &&
              <div className={`left`}>
                <Left />
              </div>
            }
            <div className={`right`}>
              {/* Frank's needs: 2025-05-30 (remove close button temporarily) */}
              {/* {
                setting.onlyForm ?  <img className="right-close" src={"/images/close.png"}
                style={ { top: 16, right: 16 } }
                id="dialog-close" alt=""
                onClick={() => setAllShow(false)} />:
                <div id="dialog-close" 
                  className="right-close"
                  style={{
                    right: -40,
                    top: 0,
                    width: 32,
                    height: 32
                  }}
                  onClick={() => setAllShow(false)} > 
                  {CloseNew}
                </div>
              } */}
              {setting.isForgetPassword ? <ForgetPassword /> :
                setting.isSSO ? <SSO form={saveLogin} setSaveLogin={setSaveLogin} /> :
                  <Form
                    saveLogin={saveLogin}
                    setSaveLogin={setSaveLogin}
                    loginWordClick={loginWordClick}
                    h5LinkClick={h5LinkClick}
                    setting={setting}
                    descWords={descWords}
                    closeAll={() => {
                      setAllShow(false)
                    }} />
              }
            </div>
          </div>
        </div>
      }
      <div className="rotate-con" id="rotate-con">
        <img src="./images/rotate.svg" alt="Please rotate your phone." />
        <div className="rotate-title">Please rotate your phone.</div>
        <div className="rotate-subTitle">We support portrait mode only.</div>
      </div>
    </div>
  </>
  );
}

export default App;
